// Centralized form styling constants


export const FORM_STYLES = {
  LABEL: {
    fontSize: '13px',
  },
  FIELD_SIZE: 'small' as const,
  INPUT: {
    fontSize: '0.9rem',
  },
} as const;

export const S_GRID_PROPS = {
  md: 3,
  xs: 12,
} as const;

export const M_GRID_PROPS = {
  md: 6,
  xs: 12,
} as const;

export const L_GRID_PROPS = {
  md: 9,
  xs: 12,
} as const;


export const XL_GRID_PROPS = {
  md: 12,
  xs: 12,
} as const;

// Extended Grid Props with styles
export const TEXT_FIELD_M_GRID_PROPS = { ...M_GRID_PROPS, sx: { marginLeft: "-12px" } } as const;
export const TEXT_FIELD_XL_GRID_PROPS = { ...XL_GRID_PROPS, sx: { marginLeft: "0px" } } as const;
export const CHECKBOX_GRID_PROPS = { xs: 12, sx: { display: "flex", alignItems: "center", marginTop: 0 } } as const;
export const CHECKBOX_S_GRID_PROPS = { ...S_GRID_PROPS, sx: { display: "flex", alignItems: "center", marginTop: 0, paddingTop: 0 } } as const;

// Form field options
export const YES_NO_OPTIONS = [
  { value: "Y", label: "Yes" },
  { value: "N", label: "No" },
];

export const MAX_TEXT_LENGTH = 100;





export const FORM_CLASSES = {
  LABEL_BASE: 'mt-0 mb-10',
  FORM_CONTROL: 'radio-group value-range',
  FILTER_MARGIN: 'filter-margin',
} as const;

export const THEME = {
    components: {
      MuiStepLabel: {
        styleOverrides: {
          iconContainer: {
            display: "none",
          },
        },
      },
      MuiStepConnector: {
        styleOverrides: {
          line: {
            display: "none",
          },
        },
      },
      MuiStep: {
        styleOverrides: {
          horizontal: {
            width: "50%", // 50% for 2 steps
            padding: "0",
          },
        },
      },
      MuiStepButton: {
        styleOverrides: {
          root: {
            margin: "initial",
            padding: "0",
            zIndex: "1",
            height: "50px",
            fontWeight: "bold",
            fontStyle: "italic",
            letterSpacing: "1px",
            textTransform: "uppercase",
          },
        },
      },
    },
  }

export const PDF_STYLES = {
  page: {
    padding: 32,
    fontSize: 9,
    fontFamily: "Helvetica",
  },

  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },

  headerLeft: {
    width: 120,
    alignItems: "flex-start",
    justifyContent: "center",
    marginLeft: -35,
  },

  headerCenter: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  headerRightSpacer: {
    width: 120,
  },

  logo: {
    width: 120,
    height: 50,
    objectFit: "contain",
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 2,
    textAlign: "center",
    color: "#0033A0",
  },

  instructions: {
    fontSize: 10,
    textAlign: "left",
    marginBottom: 12,
    lineHeight: 1.3,
    alignSelf: "flex-start",
    maxWidth: 520,
  },

  sectionHeader: {
    fontSize: 10,
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 6,
  },

  row: {
    flexDirection: "row",
    alignItems: "flex-end",
    marginBottom: 6,
  },

  label: {
    width: 160,
    fontSize: 9,
  },

  labelInline: {
    fontSize: 9,
    marginRight: 6,
  },

  line: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    minHeight: 10,
    paddingLeft: 4,
    justifyContent: "flex-end",
  },

  lineThick: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    minHeight: 10,
    paddingLeft: 4,
    justifyContent: "flex-end",
  },

  twoColRow: {
    flexDirection: "row",
    gap: 16,
    marginBottom: 6,
  },

  col: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-end",
  },

  barcodeBlock: {
    marginTop: 10,
    alignItems: "center",
  },

  // ── Barcode image sized to match generateBarcodeBase64 output ──────────
  // generateBarcodeBase64 logical canvas: width=280, barHeight=70
  // We render it at a comfortable display size; react-pdf will downsample
  // cleanly from the 4× high-res PNG, keeping bars razor-sharp.
  barcodeImage: {
    width: 220,    // display width in PDF points  (narrower than before)
    height: 90,    // display height in PDF points (tight to actual content)
    objectFit: "contain",
    marginTop: 8,
    marginBottom: 8,
  },

  proNumberBox: {
    border: "2px solid #000",
    padding: 32,
    marginTop: 20,
    marginBottom: 30,
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 120,
  },

  proNumberText: {
    fontSize: 22,
    fontWeight: "bold",
  },

  proNumberInstruction: {
    fontSize: 9,
    textAlign: "center",
    marginBottom: -12,
    paddingTop: 10,
  },
};